module.exports = __webpack_public_path__ + "static/media/Denise Borecki_front cover.261ab1c9.jpg";